export const PREVIEW_SUFFIX = '_preview';
export const PRINT_SUFFIX = '_printing';

// Replace ':' and '.' to avoid storage issues in keys
export const toSafeIso = (date = new Date()) =>
  date.toISOString().replace(/[:.]/g, '-');

// Short and stable: no timestamp to avoid overly long object names.
// Uniqueness is ensured by downstream suffixes and per-design index.
export const buildUploadBaseName = (viewId) => {
  const safeView = viewId || 'view';
  return `${safeView}`;
};

export const derivePreviewKey = (base) => `${base}${PREVIEW_SUFFIX}`;
export const derivePrintKey = (base) => `${base}${PRINT_SUFFIX}`;

// Build simple human-friendly filenames for QA/downloads
// type: 'preview' | 'printing'
export const buildIndexedFilename = (type, index, ext = 'png') => {
  const safeType = type === 'printing' ? 'printing' : 'preview';
  const idx = Number(index) > 0 ? Number(index) : 1;
  const safeExt = ext && typeof ext === 'string' ? ext.replace(/[^a-zA-Z0-9]/g, '') : 'png';
  return `${safeType}_${idx}.${safeExt}`;
};
